import {
  Checkbox,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface FilterSectionCheckboxFilterProps {
  headerSource: string
  checkboxProps: Array<{
    labelSource: string
    onChange: (checked: boolean) => void
    checked: boolean
  }>
}

const FilterSectionCheckboxFilter: React.FC<
  FilterSectionCheckboxFilterProps
> = (props): React.ReactElement => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={props.headerSource} />
      </div>
      {props.checkboxProps.map((checkboxProp, index) => (
        <Checkbox
          key={index + checkboxProp.labelSource}
          label={<Trns source={checkboxProp.labelSource} />}
          onClick={(): void => {
            checkboxProp.onChange(!checkboxProp.checked)
          }}
          isSelected={checkboxProp.checked}
        />
      ))}
    </div>
  )
}

export default FilterSectionCheckboxFilter
